import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from '@nuxtjs/composition-api'
import { useMenuModel, MenuDetailModal } from '@entities/menu'
import { IProduct } from './../model/types'
import { MenuProductList } from '@widgets/menu'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuList',
  setup(__props) {

const menuModel = useMenuModel()

const detailProduct = ref<IProduct | null>(null)
const isDetailVisible = ref(false)

watch(() => menuModel.menuUser, () => {
  if (detailProduct.value) {
    menuModel.menuUser.forEach((i) => {
      i.products.forEach((j) => {
        if (detailProduct.value && j.id === detailProduct.value.id) {
          detailProduct.value = j
        }
      })
    })
  }
})

const stepEnterHandler = ({ index }: { index: number }) => {
  const links = document.querySelectorAll('.menu-categories__item')
  for (let i = 0; i < links.length; i++) {
    links[i].classList.remove('active')
  }
  links[index].classList.add('active')
  const leftElem = (links[index] as HTMLElement).offsetLeft
  const categoryScrollEl = document.querySelector(
    '.menu-categories__list'
  )
  if (categoryScrollEl) {
    categoryScrollEl.scrollTo(leftElem, 0)
  }
}

const setDetailProduct = (product: IProduct) => {
  detailProduct.value = product
  isDetailVisible.value = true
}

const closeDetail = () => {
  isDetailVisible.value = false
}

const handleAfterLeave = () => {
  detailProduct.value = null
}

return { __sfc: true,menuModel, detailProduct, isDetailVisible, stepEnterHandler, setDetailProduct, closeDetail, handleAfterLeave, MenuDetailModal, MenuProductList }
}

})